GP.collections.Threads = Backbone.Collection.extend({
    model: GP.models.Thread,

    // TODO: put url back once we're sure this isn't needed anymore (301 redirect caching issue)
    url: '/members/msg/get_inbox',
    // url: '/main.php?a=msg.get_inbox',

    special_msg_ids:    [1], // special msg_ids for special sorting
    initialize: function() {
        // TODO: not sure if this is still needed (ported over from fling2 MessagingApp)
        this.on('change:msg_id', function() { this.sort(); });

        this.min_msg_id = 0;
        this.max_msg_id = 0;
        this.min_safe_int = -(Math.pow(2, 53) - 1);
    },
    parse: function(data) {
        if (data.first_page_reached) {
            GP.vent.trigger('MessagePane.Inbox:set_first_page_reached');
        }
        GP.sdata.MessagingUsers.add(data.users);
        return data.threads;
    },
    comparator: function(model) {
        var msg_id = parseInt(model.get('msg_id'), 10);
        var priority = _.contains(model.get('tag'), 'PRIORITY') ? 1 : 0;

        // comparator looks at every incoming model by default so do any extra work
        // we need to here rather than looping over the models again somewhere else
        // don't set min/max msg_id if msg_id is in the special_msg_id array
        // or if the msg is a priority message, since those msg_ids will be out of order
        if (!priority && $.inArray(msg_id, this.special_msg_ids) === -1) {
            this.set_msg_ids(msg_id);
        }

        // ------- COMPARATOR CODE --------- //
        var unread = parseInt(model.get('unread_total'), 10) > 0 ? 1 : 0;
        var setToTop = (priority && unread) ? 1 : 0;

        var sort_id = msg_id;
        if ($.inArray(msg_id, this.special_msg_ids) !== -1) {
            sort_id = this.min_safe_int;
        } else {
            sort_id = -((setToTop * Math.pow(2,50)) + msg_id);
        }
        return sort_id;
    },
    set_msg_ids: function(msg_id) {
        if (this.min_msg_id === 0 || msg_id < this.min_msg_id) {
            this.min_msg_id = msg_id;
        }
        if (this.max_msg_id === 0 || msg_id > this.max_msg_id) {
            this.max_msg_id = msg_id;
        }
    },
    reset_metadata: function() {
        this.min_msg_id = 0;
        this.max_msg_id = 0;
    },
    filter_by_id: function(id_array) {
        return this.reset(_.map(id_array, function(id) { return this.get(id); }, this));
    }
});
